<template>
  <section id="favorite" class="c__section section__favorite">
    <div class="c__container">
      <div class="c__headblock">
        <h2 class="c__leadcopy navy c__no__anm"> 自分好みの商品を見つけよう </h2>
        <p class="navy c__bodycopy c__no__anm">
          季節や好みに合わせて様々な素材やシルエットをご用意しています。<br class="hidden-xs" />
          あなた好みのBAKUNEをみつけましょう
        </p>
      </div>
      <div class="favorite__wrap">
        <div class="favorite__container">
          <div>
            <div class="favorite__select__wrap">
              <!-- 高さが崩れないようにローディングを表示 -->
              <AtomsConsumerLoading v-if="!isLoaded" />
              <FeaturesHowtochooseRecoverywearSleepitemPartsSearchConditionList
                v-else
                :products="products"
                :selected="selected"
                class="favorite__select"
                @change="onChange"
              />
            </div>
            <div class="favorite__img">
              <AtomsConsumerLoading v-if="!selectedProducts[0]?.skus?.[0].main_image" />
              <AtomsConsumerImage
                v-else
                :src="selectedProducts[0]?.skus?.[0].main_image ?? ''"
                :alt="selectedProducts[0]?.name ?? ''"
                :width="412"
                :height="412"
              />
            </div>
          </div>
          <AtomsConsumerLink
            :url="selectedProducts[0] ? getSiteProductPageUrl(selectedProducts[0]) : ''"
            class="c__btn c__fit-content c__anm detail__btn c__no__anm"
          >
            <p>商品を見る</p>
          </AtomsConsumerLink>
        </div>
      </div>
    </div>
    <div class="sticky__height"></div>
  </section>
</template>

<script setup lang="ts">
import { BakuneTopProduct, SearchConditionSelected } from "~/utils/functions/howtochoose_recoverywear_sleepitem"
import { getSiteProductPageUrl } from "~/utils/functions/product"

const props = defineProps<{
  products: BakuneTopProduct[]
}>()

const selected = ref<SearchConditionSelected>({
  sex: "mens",
  silhouette: "pullover",
  fabric: "dry",
  sleevesAndPants: "short-sleeve-short-pants",
  detail: "",
})

const selectedProducts = ref<BakuneTopProduct[]>([])
const isLoaded = ref(false)
const sessionKey = "howtochoose_recoverywear_sleepitem_favorite"

const emit = defineEmits<{
  (e: "updateFavorite", searchConditionSelected: SearchConditionSelected): void
}>()

const onChange = (payload: {
  searchConditionSelected: SearchConditionSelected
  selectedProducts: BakuneTopProduct[]
}) => {
  selected.value = payload.searchConditionSelected
  selectedProducts.value = payload.selectedProducts
  // 選択した条件をセッションストレージに保存
  sessionStorage.setItem(sessionKey, JSON.stringify(selected.value))
  emit("updateFavorite", selected.value)
}

onMounted(() => {
  // 選択した条件をセッションストレージから取得
  const savedSelected = sessionStorage.getItem(sessionKey)
  if (savedSelected) {
    selected.value = JSON.parse(savedSelected) as SearchConditionSelected
  }
})

watch(
  () => props.products,
  () => {
    isLoaded.value = true
  },
)
</script>

<style scoped lang="scss">
@import "assets/scss/pages/howtochoose_recoverywear_sleepitem/main";
</style>
